import {SectionItem} from 'common/components/items-menu/types';

import {CountType, FunnelOrder} from './types';

export const SEGMENT_SEPARATOR = ` / `;
export const OVERALL_PROP = `$overall`;
export const OVERALL_PROP_NAME = `Overall`;

export const MAX_SEGMENTS = 10;
export const NUM_DEFAULT_SEGMENTS = 5;

export const STEPS_DISPLAY_DATE_FORMAT = `ddd MMM DD YYYY`;

export const COUNT_TYPE_OPTIONS: SectionItem[] = [
  {
    label: `Uniques`,
    value: CountType.Unique,
  },
  {
    label: `Totals`,
    value: CountType.General,
  },
  {
    label: `Sessions`,
    value: CountType.Session,
  },
];
export const ORDER_OPTIONS: SectionItem[] = [
  {
    label: `specific order`,
    value: FunnelOrder.Loose,
  },
  {
    label: `any order`,
    value: FunnelOrder.Any,
  },
];
